module.exports = __webpack_public_path__ + "d308073b/img/lock-icon.bb9c7166.svg";